export function pluralise(word: string, count: number) {
  return count === 1 ? word : word + "s";
}

export const camelToFlat = (camel: string) => {
  const flat = camel.replace(/([a-z])([A-Z])/g, "$1 $2");
  return flat.charAt(0).toUpperCase() + flat.slice(1);
};
